/** Parse a Google Drive folder/file URL or a raw resource id. */

const FOLDER_PATH = /\/(?:folders|d|file\/d|shared-drives)\/([a-zA-Z0-9_-]+)/;
const OPEN_ID = /[?&]id=([a-zA-Z0-9_-]+)/;
const RAW_ID = /^[a-zA-Z0-9_-]{10,}$/;

export function parseGoogleDriveResourceId(raw: string): string | null {
  const trimmed = raw.trim().replace(/^["']+|["']+$/g, "");
  if (!trimmed) return null;
  if (RAW_ID.test(trimmed) && !trimmed.includes("/")) return trimmed;
  try {
    const u = new URL(trimmed);
    const fromPath = FOLDER_PATH.exec(u.pathname);
    if (fromPath?.[1]) return fromPath[1];
    const fromQuery = OPEN_ID.exec(`?${u.searchParams.toString()}`) ?? OPEN_ID.exec(trimmed);
    if (fromQuery?.[1]) return fromQuery[1];
  } catch {
    /* not a URL */
  }
  const loose = /(?:^|\/)([a-zA-Z0-9_-]{10,})\s*$/.exec(trimmed);
  return loose?.[1] ?? null;
}
